export default __webpack_public_path__ + "static/media/omni-logo-icon-only.5884dd78.png";